import { PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState, AppDispatch } from './store';
import { toggleTheme } from './store/themeConfigSlice';
import { fetchMe } from './store/authSlice';
import store from './store';
import { RealtimeProvider } from './realtime/RealtimeProvider';

function App({ children }: PropsWithChildren) {
    const themeConfig = useSelector((state: IRootState) => state.themeConfig);
    const authInitialized = useSelector((state: IRootState) => state.auth.initialized);
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(toggleTheme(localStorage.getItem('theme') || themeConfig.theme));
    }, [dispatch, themeConfig.theme]);

    useEffect(() => {
        if (!authInitialized) {
            dispatch(fetchMe());
        }
    }, [dispatch, authInitialized]);

    return (
        <div
            className={`${(store.getState().themeConfig.sidebar && 'toggle-sidebar') || ''} ${themeConfig.menu} ${themeConfig.layout} main-section antialiased relative font-figtree text-sm font-normal`}
        >
            {/* App instalado: o conteúdo rola por baixo da barra de status e o iOS desfoca a faixa;
                esta tampa opaca cobre a área + a borda desfocada (altura 0 fora do modo standalone). */}
            <div
                aria-hidden
                className="fixed inset-x-0 top-0 z-[60] h-[env(safe-area-inset-top)] [@media(display-mode:standalone)]:h-[calc(env(safe-area-inset-top)+1rem)] bg-white dark:bg-surface-card pointer-events-none print:hidden"
            />
            <RealtimeProvider>{children}</RealtimeProvider>
        </div>
    );
}

export default App;
